<template>
  <div
    v-if="loading"
    class="ma-5 text-xs-center"
  >
    <v-progress-circular
      indeterminate
      :size="32"
      color="accent"
    />
  </div>
  <div
    v-else
    class="ma-3"
  >
    <div
      layout="row"
      class="mx-3"
    >
      <div
        class="title pb-2"
        style="width: 300px"
      >
        Statistics
      </div>
      <div
        class="mx-3"
        layout="row"
        layout-align="start center"
        flex
      >
        <v-select
          v-model="application"
          v-focus
          solo
          single-line
          hide-details
          label="Application"
          :items="apps"
          class="mr-3"
          style="max-width: 250px"
          @change="onAppChange"
        />
        <div layout="column">
          Date range:
        </div>
        <div
          layout="column"
          class="ml-4"
        >
          <div
            layout="row"
            layout-align="start center"
          >
            <v-menu
              ref="searchStart"
              :close-on-content-click="false"
              :return-value.sync="start"
              transition="scale-transition"
              offset-y
              lazy
              full-width
            >
              <v-icon slot="activator">
                event
              </v-icon>
              <v-date-picker
                v-model="start"
                first-day-of-week="1"
                @input="$refs.searchStart.save(start); start_text = americanizeDate(start); updateEnd(); localStorage.setItem(startKey, start);"
              />
            </v-menu>
            <v-text-field
              v-model="start_text"
              label="from"
              class="ml-2 mr-4"
              @blur="start = parseDate(start_text); localStorage.setItem(startKey, start);"
            />
            <v-menu
              ref="searchEnd"
              :close-on-content-click="false"
              :return-value.sync="end"
              transition="scale-transition"
              offset-y
              full-width
            >
              <v-icon slot="activator">
                event
              </v-icon>
              <v-date-picker
                ref="end"
                v-model="end"
                first-day-of-week="1"
                @input="$refs.searchEnd.save(end); end_text = americanizeDate(end); localStorage.setItem(endKey, end);"
              />
            </v-menu>
            <v-text-field
              v-model="end_text"
              label="to"
              class="ml-2"
              @blur="end = parseDate(end_text); localStorage.setItem(endKey, end);"
            />
          </div>
        </div>
        <div
          layout="column"
          class="ml-4"
        >
          <v-btn
            depressed
            color="primary"
            large
            @click="filter"
          >
            Filter
          </v-btn>
        </div>
        <div
          layout="column"
          class="ml-1"
        >
          <div layout="row">
            or&nbsp;
            <a
              class="grey--text "
              @click.prevent="init"
            >init</a>
          </div>
        </div>
        <div
          layout="column"
          flex
        >
          <div
            layout="row"
            layout-align="end center"
          >
            <v-btn
              color="primary"
              outline
              :loading="loadingXLSX"
              class="ml-5"
              :disabled="!start || !end"
              @click="exportExcel"
            >
              <v-icon>mdi-file-excel</v-icon>
              Export
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div
      layout="row"
      class="mt-3"
    >
      <v-list class="sidebar">
        <template v-for="(item,k) in sidebarOptions">
          <v-list-tile
            v-if="!item.children"
            :key="k"
            :to="{name: item.link, params: {id: $route.params.id}}"
          >
            <v-list-tile-avatar>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-title>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile>
          <v-list-group
            v-else
            :key="k"
          >
            <v-list-tile slot="activator">
              <v-list-tile-avatar>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              :to="{name: child.link, params: child.params}"
            >
              <v-list-tile-avatar />
              <v-list-tile-title class="pl-2">
                {{ child.text }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>
        </template>
      </v-list>

      <router-view
        :key="$route.path"
        class="mx-3"
        flex
        :start.sync="start"
        :end.sync="end"
        :application.sync="application"
        :start-text.sync="start_text"
        :end-text.sync="end_text"
        :to-filter.sync="toFilter"
      />
    </div>
  </div>
</template>

<script>
import Statistics from '@/api/statistics'
import Consts from '@/consts'
import Auth from '@/plugins/auth'
import moment from 'moment'
import GlobalMixin from "@/mixins/global"

export default {
  mixins: [GlobalMixin],
  data () {
    return {
      loading: false,
      start: moment().startOf('month').format('YYYY-MM-DD'),
      end: moment().endOf('month').format('YYYY-MM-DD'),
      start_text: moment().startOf('month').format('DD.MM.YYYY'),
      end_text: moment().endOf('month').format('DD.MM.YYYY'),
      application: null,
      toFilter: false,
      loadingXLSX: false,
      isTrainer: false,
      startKey: 'stats-start',
      endKey: 'stats-end',
      localStorage
    }
  },
  computed: {
    sidebarOptions () {
      let arr = []

      if(this.application != Consts.APPLICATION.FREELANCES){
        arr.push({ text: 'Entities / Global Information', icon: 'mdi-bank', link: 'statistics-entities' })
      }

      arr.push({ text: 'Sessions per type/concept', icon: 'mdi-help-circle', link: 'statistics-types-topics' })

      if (!this.isTrainer) {
        let tgTypes = []
        let evalRoute = {}
        if(this.application == Consts.APPLICATION.FREELANCES){
          tgTypes = [
            { text: 'Activities', link: 'statistics-target', params: { sessionType: Consts.ACTIVITY } },
            { text: 'Internal meetings AS', link: 'statistics-target', params: { sessionType: Consts.INTERNAL_AS } },
          ]

          evalRoute = {
            text: 'Evaluation forms',
            icon: 'mdi-thumbs-up-down',
            link: 'statistics-evals-export'
          }
        } else {
          tgTypes = [
            { text: 'Events', link: 'statistics-target', params: { sessionType: Consts.EVENTS } },
            { text: 'Adults training', link: 'statistics-target', params: { sessionType: Consts.ADULTS } },
            { text: 'School training', link: 'statistics-target', params: { sessionType: Consts.SCHOOL } },
            { text: 'Teacher\'s training', link: 'statistics-target', params: { sessionType: Consts.TEACHERS } },
            { text: 'Youth training', link: 'statistics-target', params: { sessionType: Consts.YOUTH } },
            { text: 'Others', link: 'statistics-target', params: { sessionType: Consts.OTHER } }
          ]

          evalRoute = {
            text: 'Evaluation forms',
            icon: 'mdi-thumbs-up-down',
            children: [
              { text: 'Adults training', link: 'statistics-evals', params: { sessionType: Consts.ADULTS } },
              { text: 'School training', link: 'statistics-evals', params: { sessionType: Consts.SCHOOL } },
              { text: 'Teacher\'s training', link: 'statistics-evals', params: { sessionType: Consts.TEACHERS } },
              { text: 'Youth training', link: 'statistics-evals', params: { sessionType: Consts.YOUTH } },
              { text: 'Internal meetings', link: 'statistics-evals', params: { sessionType: Consts.INTERNAL } },
              { text: 'Others', link: 'statistics-evals', params: { sessionType: Consts.OTHER } }
            ]
          }
        }

        arr.push({ text: 'Sessions per trainer', icon: 'mdi-account-multiple', link: 'statistics-trainers' })
        arr.push(evalRoute)
        arr.push({
          text: 'Target groups',
          icon: 'mdi-target',
          children: tgTypes
        })

        if(this.application != Consts.APPLICATION.FREELANCES){
          arr.push({ text: 'CSV for the University', icon: 'mdi-download-network', link: 'statistics-univ' })
          arr.push({ text: 'Events', icon: 'mdi-star-circle', link: 'statistics-events' })
        }
      }

      return arr
    }
  },
  created() {
    this.application = this.getStoredApp()

    if(!this.application){
      this.application = 1
    }

    let s = localStorage.getItem(this.startKey)
    if (s) {
      this.start = s
      this.start_text = this.americanizeDate(s)
    }

    let e = localStorage.getItem(this.endKey)
    if (e) {
      this.end = e
      this.end_text = this.americanizeDate(e)
    }

    this.loadUser()
  },
  methods: {
    onAppChange(v){
      this.setStoredApp(v)

      if(v == Consts.APPLICATION.FREELANCES && (this.$route.name == 'statistics-entities' || this.$route.name == 'statistics-events' || this.$route.name == 'statistics-univ')){
        this.$router.push({name: 'statistics-types-topics'})
      } else if (this.$route.name == 'statistics-target'){
        if(v == Consts.APPLICATION.FREELANCES){
          this.$router.push({name: 'statistics-target', params: { sessionType: Consts.ACTIVITY }})
        }else {
          this.$router.push({name: 'statistics-target', params: { sessionType: Consts.EVENTS }})
        }
      } else if(v == Consts.APPLICATION.FREELANCES && this.$route.name == 'statistics-evals'){
        this.$router.push({name: 'statistics-evals-export'})
      } else if (v == Consts.APPLICATION.BEESECURE && this.$route.name == 'statistics-evals-export'){
        this.$router.push({name: 'statistics-evals', params: { sessionType: Consts.ADULTS }})
      }

      this.$nextTick(() => {
        this.filter()
      })
    },
    updateEnd () {
      this.$refs.end.monthClick(this.start)
    },
    americanizeDate (date) {
      if (!date) return null

      if (date.indexOf('.') >= 0) {
        return date
      }

      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    parseDate (date) {
      if (!date) return null

      if (date.indexOf('-') >= 0) {
        return date
      }

      return moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD')
    },
    loadUser () {
      if (Auth.user.role == Consts.TRAINER) {
        this.isTrainer = true
      }
    },
    filter () {
      this.toFilter = true
    },
    init () {
      this.start = moment().startOf('month').format('YYYY-MM-DD')
      this.end = moment().endOf('month').format('YYYY-MM-DD')
      this.start_text = moment().startOf('month').format('DD.MM.YYYY')
      this.end_text = moment().endOf('month').format('DD.MM.YYYY')
      this.toFilter = true
      this.application = this.getDefaultApp() ? this.getDefaultApp() : 1

      localStorage.setItem(this.startKey, this.start);
      localStorage.setItem(this.endKey, this.end);
    },
    exportExcel () {
      this.loadingXLSX = true
      Statistics.exportExcel({ start: this.start, end: this.end, application: this.application }).then(res => {
        this.loadingXLSX = false
        let blob = new Blob([res.data], { type: "octet/stream" })

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, 'Export-' + this.start + '-' + this.end + ".xlsx")
        } else {
          let a = document.createElement("a")
          document.body.appendChild(a)
          a.style = "display: none"
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = 'Export-' + this.start + '-' + this.end + ".xlsx"
          a.click()
          window.URL.revokeObjectURL(url)
        }
      })
    }
  }
}
</script>

<style scoped>
.sidebar {
  border-right: 1px solid #ddd;
  width: 300px;
  background: transparent;
}
</style>